import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a89d4ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-xs" }
const _hoisted_2 = { class: "text-sm font-medium" }
const _hoisted_3 = { class: "text-sm text-gray-500 mb-2" }

import { defineComponent } from 'vue'
import { useDateFormat } from '../../composable/filters'
import { UITag } from '@gohighlevel/ghl-ui'

export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryCard',
  props: {
  item: {
    type: Object,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
  selectedVersion: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const { formatDateToMinutes } = useDateFormat()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hover:bg-gray-200 padding-y-3 padding-x-4 cursor-pointer", { 'bg-gray-100': __props.item.id === __props.selectedVersion }])
  }, [
    _createElementVNode("div", _hoisted_1, "#" + _toDisplayString(__props.count - __props.item.id), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(formatDateToMinutes)(__props.item.updatedAt)), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.item.updatedBy), 1 /* TEXT */),
    (__props.item.id === 0)
      ? (_openBlock(), _createBlock(_unref(UITag), {
          key: 0,
          id: "pg-email-builder-versions-currentversion",
          type: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('emailCampaign.currentVersion')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})